<template>
  <section>
    <v-row justify="center">
      <v-dialog v-model="confirmar" persistent max-width="330">
        <v-card>
          <v-card-title>Eliminar</v-card-title>
          <v-card-text>Esta seguro que desea eliminar el registro?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="eliminar(); confirmar = false">Aceptar</v-btn>
            <v-btn color="red darken-1" text @click="confirmar = false">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-form v-model="valid">
      <v-text-field
        class="px-3 my-3"
        full-width
        type="text"
        dense
        flat
        single-line
        :rules="[RequeridoRules, max50chars]"
        v-model="entidad[propDescripcion]"
        @change="guardar"
        append-outer-icon="mdi-delete-circle-outline"
        @click:append-outer="confirmar = true"
        hide-details
      ></v-text-field>
    </v-form>
  </section>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    modulo: String,
    propId: String,
    propDescripcion: String,
    entidad: Object
  },
  data() {
    return {
      confirmar: false,
      desc: "",
      evitarguardar: false,
      valid: false,
      RequeridoRules: value => !!value || "Requerido",
      max50chars: v => v.length <= 50 || "Maximo 50 caracteres!"
    };
  },
  methods: {
    guardar() {
      if (this.valid) {
        this.$store.dispatch(this.modulo + "/guardarEntidad", this.entidad);
      }
    },
    eliminar() {
      if (this.valid) {
        this.$store.dispatch(
          this.modulo + "/eliminar",
          this.entidad[this.propId]
        );
      }
    }
  }
};
</script>

<style>
</style>